import * as types from 'constants/ActionTypes';
import initialState from 'config/initialState';


function usernames(usersById) {
  const byUsername = {};
  Object.keys(usersById).forEach((id) => {
    byUsername[usersById[id].username] = parseInt(id, 10);
  });
  return byUsername;
}

function chargersList(usersById, chargers) {
  const users = {};
  chargers.forEach((charger) => {
    if (charger.reviews !== undefined) {
      charger.reviews.forEach((review) => {
        if (review.user) {
          users[review.user.pk] = Object.assign({}, usersById[review.user.pk] || null, review.user);
        }
      });
    }
  });
  return {
    byId: users,
    byUsername: usernames(users),
  };
}

export default function usersReducer(state = initialState.users, action) {
  let user;
  const byId = {};
  let results;

  switch (action.type) {

    case types.CHARGERS.SUCCESS:
      results = chargersList(state.byId, action.response.results);
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, results.byId),
        byUsername: Object.assign({}, state.byUsername, results.byUsername),
      });

    case types.CHARGERS_NEAR_IP.SUCCESS:
      results = chargersList(state.byId, action.response.results.data);
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, results.byId),
        byUsername: Object.assign({}, state.byUsername, results.byUsername),
      });

    case types.CHARGER_REVIEWS.SUCCESS: {
      action.response.results.forEach((review) => {
        if (review.user && review.user.pk) {
          byId[review.user.pk] = Object.assign({}, state.byId[review.user.pk] || null, review.user);
        }
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });
    }

    case types.CHARGER_IMAGES.SUCCESS:
      action.response.results.forEach((image) => {
        if (image.uploaded_by) {
          byId[image.uploaded_by.pk] = Object.assign(
            {},
            state.byId[image.uploaded_by.pk] || null,
            byId[image.uploaded_by.pk] || null,
            image.uploaded_by,
          );
        }
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    case types.PLACE_REVIEWS.SUCCESS:
      action.response.results.forEach((review) => {
        if (review.user) {
          byId[review.user.pk] = Object.assign({}, state.byId[review.user.pk] || null, review.user);
        }
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    case types.NEW_CHARGER_REVIEW.SUCCESS:
      user = action.response.user;
      byId[user.pk] = Object.assign({}, byId[user.pk] || null, user, {
        num_charger_reviews: state.byId[user.pk].num_charger_reviews + 1,
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });

    case types.NEW_CHARGER_IMAGE:
      if (action.image.uploaded_by && action.image.uploaded_by.pk) {
        byId[action.image.uploaded_by.pk] = Object.assign(
          {}, byId[action.image.uploaded_by.pk] || null, action.image.uploaded_by);
      }
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    case types.NEW_PLACE_REVIEW.SUCCESS:
      user = action.response.user;
      byId[user.pk] = Object.assign({}, state.byId[user.pk] || null, user, {
        num_place_reviews: state.byId[user.pk].num_place_reviews + 1,
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
      });

    case types.USER.SUCCESS: {
      user = action.response;
      let chargerReviews = [];
      let placeReviews = [];
      if (user.charger_reviews) {
        chargerReviews = user.charger_reviews.map(review => (review.pk));
      }
      if (user.place_reviews) {
        placeReviews = user.place_reviews.map(review => (review.pk));
      }
      byId[user.pk] = Object.assign({}, state.byId[user.pk] || null, user, {
        charger_reviews: chargerReviews,
        place_reviews: placeReviews,
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });
    }

    case types.USERS.SUCCESS:
      action.response.results.forEach((result) => {
        byId[result.pk] = Object.assign({}, state.byId[result.pk] || null, result);
      });
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    case types.LOGIN.SUCCESS:
      byId[action.response.pk] = Object.assign(
        {}, state.byId[action.response.pk] || null, action.response);
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    case types.CURRENT_USER.SUCCESS:
      byId[action.response.pk] = Object.assign(
        {}, state.byId[action.response.pk] || null, action.response);
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    case types.UPDATE_USER:
      byId[action.user.pk] = Object.assign({}, state.byId[action.user.pk] || null, action.user);
      return Object.assign({}, state, {
        byId: Object.assign({}, state.byId, byId),
        byUsername: Object.assign({}, state.byUsername, usernames(byId)),
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/scripts/reducers/UserReducers.js